/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

export const connectServicesActivationModalInitialState = { show: false };

export const initialState = {
  connectServicesActivationModal: connectServicesActivationModalInitialState,
};

export const addonsSlice = createSlice({
  name: "addons",
  initialState,
  reducers: {
    openConnectServicesActivationModal: (state) => {
      state.connectServicesActivationModal = { ...connectServicesActivationModalInitialState, show: true };
    },
    closeConnectServicesActivationModal: (state) => {
      state.connectServicesActivationModal = connectServicesActivationModalInitialState;
    },
  },
});

export const { openConnectServicesActivationModal, closeConnectServicesActivationModal } =
  addonsSlice.actions;

export default addonsSlice.reducer;
